import { TypedAction } from '@ngrx/store/src/models';
import { setPropertySpaceFilterBasedOnUrlValues } from './property-space.actions';
import { AppState, UrlPartSerializer } from '@immosky/types';

export class PropertySpaceFilterSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    const values = urlValue.split(',').map((v) => v.trim());

    const min = parseInt(values[0], 10);
    const max = parseInt(values[1], 10);

    return setPropertySpaceFilterBasedOnUrlValues({
      values: {
        min,
        max,
      },
    });
  }

  serialize(state: AppState): string {
    const propertySpaceFilter = state.filter.propertySpace.filter;
    return `${propertySpaceFilter.min.value},${propertySpaceFilter.max.value}`;
  }
}
